<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">
      <!-- En-tête -->
      <div class="row mb-5">
        <div class="col-12 text-center">
          <!-- <h2 class="section-title">Les Equipes</h2> -->
          <p class="section-subtitle">Elles aident l’EITP à atteindre ses objectifs à travers la préparation des activités. Leur champ d’action, c’est l’école. Les apprenants et les anciens de l’EITP peuvent librement faire partie de ces équipes pour porter leur contribution à la vie de l’école.</p>
        </div>
      </div>

      <!-- Grille des formations -->
      <div class="row">
        <div 
          class="col-xl-3 col-lg-4 col-md-6 mb-4" 
        >
          <div class="formation-card">
            <div class="formation-icon-wrapper">
              <i class="flaticon-education formation-icon"></i>
              <h5 class="formation-title title-on-blue">Liturgie</h5>
            </div>
            <div class="formation-content">
              <!-- <h5 class="formation-title">Liturgie</h5> -->
              <div class="formation-niveau">
                <i class="flaticon-level"></i>
                <span>Préparation des activités liturgiques (récollections, messes, prières, célébrations de la parole) et de tout ce qui entre dans ce cadre (lectures, monitions, prière universelles).</span>
              </div>
            </div>
          </div>
        </div>
        <div 
          class="col-xl-3 col-lg-4 col-md-6 mb-4" 
        >
          <div class="formation-card">
            <div class="formation-icon-wrapper">
              <i class="flaticon-education formation-icon"></i>
              <h5 class="formation-title title-on-blue">Chorale</h5>
            </div>
            <div class="formation-content">
              <!-- <h5 class="formation-title">Chorale</h5> -->
              <div class="formation-niveau">
                <i class="flaticon-level"></i>
                <span>Animation des activités liturgiques (récollections, messes, prières, célébrations de la parole).</span>
              </div>
            </div>
          </div>
        </div>
        <div 
          class="col-xl-3 col-lg-4 col-md-6 mb-4" 
        >
          <div class="formation-card">
            <div class="formation-icon-wrapper">
              <i class="flaticon-education formation-icon"></i>
              <h5 class="formation-title title-on-blue">Organisation</h5>
            </div>
            <div class="formation-content">
              <!-- <h5 class="formation-title">Organisation</h5> -->
              <div class="formation-niveau">
                <i class="flaticon-level"></i>
                <span>Logistique et Préparation pratique (différentes étapes) des diverses activités de l’école.</span>
              </div>
            </div>
          </div>
        </div>
        <div 
          class="col-xl-3 col-lg-4 col-md-6 mb-4" 
        >
          <div class="formation-card">
            <div class="formation-icon-wrapper">
              <i class="flaticon-education formation-icon"></i>
              <h5 class="formation-title title-on-blue">Revue de l'école</h5>
            </div>
            <div class="formation-content">
              <!-- <h5 class="formation-title">Revue de l'école</h5> -->
              <div class="formation-niveau">
                <i class="flaticon-level"></i>
                <span>Animation et gestion de la Parution de la « Revue ».
Animation et compte-rendu des activités de l’école pour le site de l’école. Parution (semestrielle) : Noël et Pentecôte.
</span>
              </div>
            </div>
          </div>
        </div>
        
        
      </div>
    </div>
  </div>
</template>

<script lang="ts">

</script>

<style scoped>
.formation-title {
  color: white !important;
}
.service-wrap {
  background-color: #f8f9fa;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 2rem;
}

.formation-card {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.formation-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.formation-icon-wrapper {
  background: linear-gradient(135deg, #0b1b3f 0%, #0b1b3f 100%);
  padding: 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.formation-icon-wrapper::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: rgba(255, 255, 255, 0.1);
  transform: rotate(45deg);
  transition: all 0.5s ease;
}

.formation-card:hover .formation-icon-wrapper::before {
  top: -100%;
  right: -100%;
}

.formation-icon {
  font-size: 64px;
  color: white;
  position: relative;
  z-index: 1;
}

.formation-content {
  padding: 25px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.formation-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1px;
  line-height: 1.4;
  min-height: 0px;
}

.formation-niveau {
  display: flex;
  align-items: center;
  background: #fff8e1;
  padding: 12px 15px;
  border-radius: 8px;
  border-left: 4px solid #ffc107;
}

.formation-niveau i {
  font-size: 20px;
  color: #f9a825;
  margin-right: 10px;
}

.formation-niveau span {
  font-size: 0.95rem;
  font-weight: 600;
 
}

.no-data {
  padding: 60px 20px;
}

.no-data i {
  font-size: 80px;
  color: #d0d0d0;
  margin-bottom: 20px;
}

.no-data h4 {
  font-size: 1.5rem;
  color: #6c757d;
  margin-bottom: 10px;
}

.no-data p {
  color: #adb5bd;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

/* Responsive */
@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }

  .formation-title {
    font-size: 1.1rem;
    min-height: auto;
  }

  .formation-icon {
    font-size: 48px;
  }

  .formation-icon-wrapper {
    padding: 30px;
  }
}
</style>